export const multiPartContentType = {
    'content-type': 'multipart/form-data'
};
